import React from "react";

import {
  ClaimYourInsurance,
  ExclusiveOffers,
  InsuranceStats,
  LandingFooter,
  LandingTestimonials,
  PersuasionBannerInsurance,
  SafenSecureTrav,
  WhatsCovered,
  WhyBuyTravIns,
} from "@tm/static";
import { useBreakpointV2 } from "@tm/ui-widgets";

import { Footer } from "@growth/dweb-footer";
import { Breadcrumb, SeoContent } from "@insurance/landing-ui/components";
import { PARTNER } from "@tm/isomorphic-utils";
import { usePartnerContext } from "@tm/static/partnerContext";
import LandingFaq from "../../components/LandingFaq/LandingFaq";
import { GiFooterWrap, PersuasionWrapper } from "./InsuranceLanding.style";
import { InsuranceBottomCompType } from "./types";

const data = [
  {
    title: "Popular Flight Sectors",
    links: [
      {
        text: "Kolkata to Delhi Flight",
        url: "https://www.goibibo.com/flights/kolkata-to-delhi-flights/",
      },
      {
        text: "Hyderabad to Delhi Flight",
        url: "https://www.goibibo.com/flights/hyderabad-to-delhi-flights/",
      },
    ],
  },
];

const InsuranceBottomComp = ({
  bottomCompData,
  footerInfo,
}: InsuranceBottomCompType) => {
  const context = usePartnerContext();
  const device = useBreakpointV2();

  const {
    TravelInsData,
    safeSecureTravel,
    whatsCovered,
    claimYourInsurance,
    testimonials,
    faq,
    seoFaq,
    customNumbers,
    crossSell,
    offers,
    seoContent,
  } = bottomCompData;

  const footerLinks =
    footerInfo
      ?.filter((data) => data.type === "section")
      ?.map((item, index) => ({
        id: index.toString(),
        label: item.title || "",
        listPoints:
          item?.links?.map((link, i) => ({
            id: i.toString(),
            label: link.title || "",
            link: link.url || "",
          })) ?? [],
        icon: "",
      })) ?? [];

  const footerHeading = footerInfo?.find((data) => data.type === "rich-text");
  const footerCopyrightData = footerInfo?.find(
    (data) => data.type === "footnote"
  );

  return (
    <React.Fragment>
      {customNumbers && <InsuranceStats data={customNumbers} />}
      {offers && <ExclusiveOffers data={offers} />}

      {TravelInsData && (
        <WhyBuyTravIns
          title={TravelInsData?.title}
          info={TravelInsData?.info}
          data={TravelInsData?.featureCard}
        />
      )}

      {safeSecureTravel && (
        <SafenSecureTrav
          data={safeSecureTravel?.safeTravCrd}
          title={safeSecureTravel?.title}
        />
      )}
      {whatsCovered && (
        <WhatsCovered
          data={whatsCovered?.travCrd}
          title={whatsCovered?.title}
          info={whatsCovered?.info}
        />
      )}

      {claimYourInsurance && (
        <ClaimYourInsurance
          title={claimYourInsurance.title}
          info={claimYourInsurance?.info}
          data={claimYourInsurance?.claimData}
        />
      )}
      {device == "lg" && crossSell && (
        <PersuasionWrapper>
          <PersuasionBannerInsurance
            crossSell={crossSell}
            btnHandler={() => {
              context === PARTNER.GI
                ? window.open(
                    "https://tripmoney.goibibo.com/partners/gi/forex/listing?utm_source=insurance_gi&utm_medium=desktop",
                    "_blank"
                  )
                : window.open("https://www.makemytrip.com/forex", "_blank");
            }}
            // info={persuasionBannerMob.info}
          />
        </PersuasionWrapper>
      )}
      {testimonials && (
        <LandingTestimonials
          customTitle={testimonials?.title}
          test={testimonials?.testimonialData}
        />
      )}

      {seoContent && <SeoContent seoContent={seoContent} />}
      <Breadcrumb
        hostname={
          context === PARTNER.GI ? "www.goibibo.com" : "www.makemytrip.com"
        }
      />

      {(faq || seoFaq) && (
        <LandingFaq
          customTitle={seoFaq?.title || faq?.title}
          faq={seoFaq?.faqList || faq?.faqList}
          customInfo={seoFaq?.info || faq?.info}
          icon={seoFaq?.icon || faq?.icon}
        />
      )}

      {context === PARTNER.GI && device == "lg" ? (
        <GiFooterWrap>
          <Footer data={data} adobe="" />
        </GiFooterWrap>
      ) : (
        <LandingFooter
          footerData={footerLinks}
          footerHeading={footerHeading}
          footerCopyrightData={footerCopyrightData}
        />
      )}
      {/* <LandingFooterInsurance /> */}
    </React.Fragment>
  );
};

export default InsuranceBottomComp;
